import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function AmosMeltzer() {
  const amosMeltzerSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Amos Meltzer",
    "jobTitle": "Corporate Development",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/amos-meltzer"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Amos Meltzer - Corporate Development"
        description="Amos Meltzer is a seasoned life sciences executive, intellectual property lawyer, and technology commercialisation expert with over 25 years of experience."
        keywords={['Amos Meltzer', 'Corporate Development', 'Life Sciences', 'Intellectual Property', 'Biotechnology']}
        ogImage="/amosMeltzer.webp"
        schema={amosMeltzerSchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Amos Meltzer</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Amos Meltzer
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Corporate Development
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/amosMeltzer.webp" 
                alt="Amos Meltzer, Corporate Development: Expert in Life Sciences, Intellectual Property, and Technology Commercialisation" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Amos Meltzer (corporate development) is a seasoned life sciences executive, intellectual property lawyer, and technology commercialisation expert with over 25 years of experience in biotechnology, pharmaceuticals, and medical devices. He has held key leadership roles, including COO at Synchron, Non-Executive Director at Paradigm Biopharmaceuticals, and Chairman of Maverick Life Sciences.
Amos has successfully led clinical development, secured funding, and negotiated high-value commercial agreements for ASX and Nasdaq-listed companies. With a strong legal and business background, he has played a pivotal role in bringing innovative medical technologies to market, making him a trusted leader in the life sciences industry.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="amos-meltzer" 
        basePath="/leadership" 
      />
    </div>
  );
}